import { postJson } from "Shared/server";
import { updateAppShellData } from "./../AppShell/action-creators";
import { nuke } from "SiteLayout/CurrentPage/cache";
import { updateUserNameOnImbox, } from "../TrackingInformation";
import { pushState, replaceState } from "Shared/history";
export const SET_NEW_IMPERSONATION = "SET_NEW_IMPERSONATION";
export function setNewImpersonation() {
    return (dispatch, getState) => {
        nuke();
        dispatch({
            type: SET_NEW_IMPERSONATION,
        });
    };
}
export function login(details) {
    return (dispatch, getState) => {
        let redirectUrl = getState().accountBox.redirectToAfterLogin.href;
        return new Promise((resolve, reject) => {
            postJson("/login", details)
                .then((result) => {
                if (result.success) {
                    if (result.shouldBeRedirected) {
                        redirectUrl = result.redirectUrl;
                    }
                    return Promise.resolve(result);
                }
                return Promise.reject(result);
            })
                .then(() => nuke())
                .then(() => {
                dispatch(updateAppShellData())
                    .then(() => resolve())
                    .then(() => !!redirectUrl ? pushState(redirectUrl) : replaceState());
            })
                .catch(reject);
        }).then(() => {
            const currentUser = getState().currentUser;
            updateUserNameOnImbox(currentUser);
        });
    };
}
export function logout() {
    return (dispatch, getState) => {
        let returnUrl = "/";
        let logoutFrom = "";
        return postJson("/Logout/OktaLogout")
            .then((r) => {
            if (r.logoutFrom === "impersonationPage") {
                returnUrl = r.returnUrl;
                logoutFrom = r.logoutFrom;
            }
            if (r.logoutFrom === "supplierPage") {
                returnUrl = r.returnUrl;
                logoutFrom = r.logoutFrom;
            }
            return Promise.resolve();
        })
            .then(() => pushState(returnUrl))
            .then(() => {
            if (logoutFrom === "" || logoutFrom === "impersonationPage") {
                dispatch(setNewImpersonation());
                return dispatch(updateAppShellData());
            }
            else {
                nuke();
                return Promise.resolve();
            }
        })
            .then(() => {
            let currentUser = getState().currentUser;
            updateUserNameOnImbox(currentUser);
        });
    };
}
export function register(email, password) {
    return (dispatch) => {
        return postJson("/register", { email, password }).then((result) => {
            return Promise.resolve(result);
        });
    };
}
export function searchUsers(query) {
    return (dispatch) => {
        return postJson("/SearchContactApi/Search", query).then((resp) => {
            return resp;
        });
    };
}
